export const SIDEBAR_NAME = {
  addQuestion: "addQuestion",
  action: "action",
  clickBehavior: "clickBehavior",
  editParameter: "editParameter",
  sharing: "sharing",
  info: "info",
};
